import { Link } from "react-router-dom";
import { Flame } from "lucide-react";

export default function MobileBookingBar() {
  return (
    <div className="lg:hidden">
      <Link
        to="/booking-studio"
        data-testid="mobile-book-btn"
        className="fixed bottom-4 left-4 right-4 z-50 btn-gold justify-center shadow-2xl"
      >
        <Flame size={18} /> RÉSERVER MA SESSION
      </Link>
    </div>
  );
}
